import React, {PropsWithChildren} from "react";
import styled from "styled-components";
import {TagRounded} from "@mui/icons-material";
import {ReactComponent as HeadIcon} from "../../../assets/treelist/head.svg"
import {ReactComponent as IntermediateIcon} from "../../../assets/treelist/intermediate.svg"
import {ReactComponent as TailIcon} from "../../../assets/treelist/tail.svg"
import {TransitionGroup} from "react-transition-group";

const StyledTreeListElement = styled.div`
  display: flex;
  flex-direction: row;
  padding-left: 8px;
  align-items: center;
  color: rgb(148, 155, 164);
  
  .tree-list-element-icon {
    position: relative;
    width: 20px;
    height: 20px;
    
    & > * {
      color: rgb(148, 155, 164) !important;
      width: 20px;
      height: 32px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);

      path {
        fill: #4E5058 !important
      }
    }
  }
  
  .tree-list-element-main {
    flex-grow: 1;
  }
`;

export enum TreeListElementRole {
    HEAD, INTERMEDIATE_PIECE, TAIL
}

export type TreeListElementProps = PropsWithChildren<{
    role: TreeListElementRole
}>

export const TreeListElement: React.FC<TreeListElementProps> = props => {
    return (
        <StyledTreeListElement>
            <div className={"tree-list-element-icon"}>
                {/*FIXME: react-dom.development.js:26923 Uncaught DOMException: Failed to execute 'createElement' on 'Document': The tag name provided ('/static/media/intermediate.7ac0db94aeb36a189888511e650c8eaa.svg') is not a valid name.*/}
                { props.role === TreeListElementRole.HEAD && (
                    <HeadIcon/>
                )}
                { props.role === TreeListElementRole.INTERMEDIATE_PIECE && (
                    <IntermediateIcon/>
                )}
                { props.role === TreeListElementRole.TAIL && (
                    <TailIcon/>
                )}
            </div>
            <div className={"tree-list-element-main"} children={props.children}/>
        </StyledTreeListElement>
    );
}

/**
 * @param arr -
 * @param map -
 * @param wrap Useful for animation -> Wrap in MUIs Collapse to animate adding & removing elements
 */
export function mapToTreeListElements<T>(
    arr: Array<T>,
    map: (x: T, index: number, array: Array<T>) => React.ReactNode,
    wrap: (e: React.ReactNode) => React.ReactNode = e => e
): React.ReactNode {
    return (
        <TransitionGroup>
            {
                arr.map((x, i, arr) => {
                    let role = TreeListElementRole.INTERMEDIATE_PIECE;
                    if (i === 0) role = TreeListElementRole.HEAD;
                    if (i === arr.length - 1) role = TreeListElementRole.TAIL;
                    return wrap(
                        <TreeListElement role={role} children={map(x, i, arr)}/>
                    )
                })
            }
        </TransitionGroup>
    );
}
